/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as Actions from '../../../actions/actions';

import { FormEditableInput } from '../../elements/EditableInput';
import { FormCustomCheckbox } from '../../elements/CustomCheckbox';
import FormDropdown from '../../elements/Dropdown';
import RadioGroup from '../../elements/RadioGroup';

import Icon from '../../icons/Icon';

import { MatchSteps } from '../../../constants/MatchSteps';

export class ContactForm extends Component {
    handleChange(event) {
        if (event.target.name === 'dbPension') {
            this.props.actions.updatePersonAttribute('adviceArea', (event.target.value) ? 557 : 393);
        }

        this.props.actions.updatePersonAttribute(event.target.name, event.target.value);
        this.forceUpdate();
    }

    renderMortgageQuestions() {
        if (this.props.person.get('adviceArea') === 392) {
            const maxWidthInputs = '280px';

            return (
            <div>
                <FormEditableInput name="mortgageValue"
                                   ref="mortgageValue"
                                   label="What is the value of the property you want to purchase or remortgage?"
                                   placeholder="£50,000"
                                   value={ this.props.person.get('mortgageValue') }
                                   widthProportion="fixed"
                                   fixedWidth={ maxWidthInputs }
                                   maskType="currency"
                                   handleChange={ this.handleChange.bind(this) }
                                   invalidSubmit={ this.props.invalidSubmit }
                                   required/>

                <FormEditableInput name="deposit"
                                   ref="deposit"
                                   label="What is your potential deposit (or remortgage amount)?"
                                   placeholder="£10,000"
                                   value={ this.props.person.get('deposit') }
                                   widthProportion="fixed"
                                   fixedWidth={ maxWidthInputs }
                                   maskType="currency"
                                   handleChange={ this.handleChange.bind(this) }
                                   invalidSubmit={ this.props.invalidSubmit }
                                   required/>

                <FormEditableInput name="annualIncome"
                                   ref="annualIncome"
                                   label="What is your annual income? (If it's a joint mortgage,
                                   enter your combined income)"
                                   placeholder="£35,000"
                                   value={ this.props.person.get('annualIncome') }
                                   widthProportion="fixed"
                                   fixedWidth={ maxWidthInputs }
                                   maskType="currency"
                                   handleChange={ this.handleChange.bind(this) }
                                   invalidSubmit={ this.props.invalidSubmit }
                                   required/>

                <p className="info-message">
                    Please ensure your property value minus your deposit doesn't exceed 5 times your income
                    as it's unlikely you'll be able to get a mortgage.
                </p>

                <label className="semi-bold inline-block push-down-10">
                    When are you looking to purchase the property or remortgage?
                </label>

                <FormDropdown name="adviceTime"
                              ref="adviceTime"
                              value={ this.props.person.get('adviceTime') }
                              optionsType="adviceTime"
                              widthProportion="fixed"
                              invalidSubmit={ this.props.invalidSubmit }
                              handleChange={ this.handleChange.bind(this) }
                              fixedWidth={ maxWidthInputs }
                              required/>
            </div>
            );
        }

        return (
            <div></div>
        );
    }

    render() {
        const maxWidthInputs = '280px';

        return (
            <div>
                <FormEditableInput name="postcode"
                                   ref="postcode"
                                   label="What is your postcode?"
                                   placeholder="SW1A 0AA"
                                   value={ this.props.person.get('postcode') }
                                   maxLength={ 8 }
                                   invalidSubmit={ this.props.invalidSubmit }
                                   widthProportion="fixed"
                                   fixedWidth={ maxWidthInputs }
                                   handleChange={ this.handleChange.bind(this) }
                                   required/>

                {this.props.person.get('adviceArea') !== 392 &&
                    <FormEditableInput name="wealthLevel"
                                       ref="wealthLevel"
                                       label="What is the total value of your savings? (excluding property)"
                                       placeholder="£50,000"
                                       value={ this.props.person.get('wealthLevel') }
                                       widthProportion="fixed"
                                       fixedWidth={ maxWidthInputs }
                                       maskType="currency"
                                       handleChange={ this.handleChange.bind(this) }
                                       invalidSubmit={ this.props.invalidSubmit }
                                       required/>
                }

                {this.props.person.get('adviceArea') === 392 &&
                    this.renderMortgageQuestions()
                }

                <FormEditableInput name="fullName"
                                   ref="fullName"
                                   label="Your full name"
                                   placeholder="Fred Smith"
                                   widthProportion="fixed"
                                   fixedWidth={ maxWidthInputs }
                                   value={ this.props.person.get('fullName') }
                                   handleChange={ this.handleChange.bind(this) }
                                   invalidSubmit={ this.props.invalidSubmit }
                                   required/>

                <FormEditableInput name="email"
                                   ref="email"
                                   label="Your email"
                                   placeholder="fred@fs.com"
                                   validations="isEmail"
                                   validationError="This is not a valid email"
                                   value={ this.props.person.get('email') }
                                   handleChange={ this.handleChange.bind(this) }
                                   invalidSubmit={ this.props.invalidSubmit }
                                   widthProportion="fixed"
                                   fixedWidth={ maxWidthInputs }
                                   hintText="This is where we will send your confirmation email"
                                   required/>

                <FormEditableInput name="phone"
                                   ref="phone"
                                   label="Your phone number"
                                   placeholder="01234 567 890"
                                   value={ this.props.person.get('phone') }
                                   maxLength={ 13 }
                                   invalidSubmit={ this.props.invalidSubmit }
                                   widthProportion="fixed"
                                   fixedWidth={ maxWidthInputs }
                                   handleChange={ this.handleChange.bind(this) }
                                   hintText="Your chosen adviser will give you a quick call to offer you ideas.
                                             Please enter a valid UK telephone number, e.g. 01234 567 890"
                                   maskType="phoneNumber"
                                   required/>

                {(this.props.person.get('adviceArea') === 393 || this.props.person.get('adviceArea') === 557) &&
                    <FormCustomCheckbox name="dbPension"
                        label="I have a final salary / defined benefit pension"
                        value={ this.props.person.get('dbPension') }
                        handleChange={ this.handleChange.bind(this) }/>
                }

                <RadioGroup
                    name="isLocationImportant"
                    label="Do you mind where your adviser is based?"
                    options={[{value:'Yes', label: 'Yes'}, {value:'No', label: 'No'}]}
                    required
                    onChange={ this.handleChange.bind(this) }
                />

                <div className="push-up-20">
                    <button className="bigger-button vouchedfor-brand" name="next"
                            onClick={ this.props.handler.bind(this, MatchSteps.CONTACT_FORM) }>
                        Get help with my mortgage
                    </button>
                </div>

                <div className="inline-block text-align-center push-up-20">
                    <div className="app__form-page__security-message">
                        <div className="app__form-page__security-message__icon">
                            <Icon icon="lock" size="22px" />
                        </div>
                        <div>
                            You are protected by SSL security. We go above and beyond industry standards
                            to ensure your data is safe
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ContactForm.propTypes = {
    person: React.PropTypes.object,
    actions: React.PropTypes.object,

    handler: React.PropTypes.func,

    invalidSubmit: React.PropTypes.bool,
    canSubmit: React.PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        person: state.reducer.get('person'),

        invalidSubmit: state.navigation.get('invalidSubmit'),
        canSubmit: state.navigation.get('canSubmit'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/steps/matching/ContactForm.jsx